<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>小売開栓結果登録</h1>
<mat-card class="cur-card">
    <h2>契約者情報</h2>
    <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="fill"
                class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                <mat-label>名義（漢字）</mat-label>
                <input id="customerName" matInput [value]="name" class="font-color-display-only" readonly="true"
                    disabled="true">
            </mat-form-field>
            <mat-form-field appearance="fill"
                class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                <mat-label>名義（カナ）</mat-label>
                <input id="paymentMethod" matInput [value]="nameKana" class="font-color-display-only" readonly="true"
                    disabled="true">
            </mat-form-field>
        </div>
    </div>
    <form [formGroup]="ctrInfoChgFormGroup">
        <div class=" tw-flex tw-flex-row tw-flex-wrap justify-between">
            <div class="tw-ml-[40px] tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[60%]">
                <mat-checkbox class="check-box" color="primary" [value]="ctrInfoChgUmu.value"
                    formControlName="ctrInfoChgUmu">契約者情報変更有無</mat-checkbox>
            </div>
        </div>
        <div [@openClose]="ctrInfoChgFormGroup.get('ctrInfoChgUmu')?.value ? 'open' : 'closed'">
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                        <mat-label>変更後　名義（漢字）</mat-label>
                        <input matInput formControlName="aftName" autocomplete="off" maxlength="50"
                            (change)="changeAfCtrperInfoForInput($event)">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                        <mat-label>変更後　名義（カナ）</mat-label>
                        <input matInput formControlName="aftNameKana" autocomplete="off" maxlength="50"
                            (change)="changeAfCtrperInfoForInput($event)">
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[36%]">
                        <mat-label>契約者電話番号１</mat-label>
                        <input id="bussiness" matInput [value]="befCtrperTelNo1" class="font-color-display-only"
                            readonly="true" disabled="true">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　契約者電話番号１</mat-label>
                        <input matInput formControlName="aftCtrperTelNo1" autocomplete="off" maxlength="50"
                            (change)="changeAfCtrperInfoForInput($event)">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　契約者電話番号区分１</mat-label>
                        <mat-select [(value)]='selectedAftCtrperTelNoDiv1.value' id="selectedAftCtrperTelNoDiv1"
                            (selectionChange)="changeAfCtrperInfoForSelect($event)">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let aftCtrperTelNoDiv1 of aftCtrperTelNoDivList1"
                                [value]="aftCtrperTelNoDiv1.value">{{aftCtrperTelNoDiv1.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[36%]">
                        <mat-label>契約者電話番号２</mat-label>
                        <input id="bussiness" matInput [value]="befCtrperTelNo2" class="font-color-display-only"
                            readonly="true" disabled="true">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　契約者電話番号２</mat-label>
                        <input matInput formControlName="aftCtrperTelNo2" autocomplete="off" maxlength="50"
                            (change)="changeAfCtrperInfoForInput($event)">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　契約者電話番号区分２</mat-label>
                        <mat-select [(value)]='selectedAftCtrperTelNoDiv2.value' id="selectedAftCtrperTelNoDiv2"
                            (selectionChange)="changeAfCtrperInfoForSelect($event)">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let aftCtrperTelNoDiv2 of aftCtrperTelNoDivList2"
                                [value]="aftCtrperTelNoDiv2.value">{{aftCtrperTelNoDiv2.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[36%]">
                        <mat-label>契約者電話番号３</mat-label>
                        <input id="bussiness" matInput [value]="befCtrperTelNo3" class="font-color-display-only"
                            readonly="true" disabled="true">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　契約者電話番号３</mat-label>
                        <input matInput formControlName="aftCtrperTelNo3" autocomplete="off" maxlength="50"
                            (change)="changeAfCtrperInfoForInput($event)">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　契約者電話番号区分３</mat-label>
                        <mat-select [(value)]='selectedAftCtrperTelNoDiv3.value' id="selectedAftCtrperTelNoDiv3"
                            (selectionChange)="changeAfCtrperInfoForSelect($event)">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let aftCtrperTelNoDiv3 of aftCtrperTelNoDivList3"
                                [value]="aftCtrperTelNoDiv3.value">{{aftCtrperTelNoDiv3.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>
    <h2>使用者情報</h2>
    <form [formGroup]="userInfoChgFormGroup">
        <div class=" tw-flex tw-flex-row tw-flex-wrap justify-between">
            <div class="tw-ml-[40px] tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[60%]">
                <mat-checkbox class="check-box" color="primary" [value]="isSameKeiyaku.value"
                    formControlName="isSameKeiyaku">契約者と同じ</mat-checkbox>
            </div>
        </div>
        <div [@openClose]="userInfoChgFormGroup.get('isSameKeiyaku')?.value ? 'closed' : 'open'">
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                        <mat-label>使用者名義（漢字）</mat-label>
                        <input id="userName" matInput [value]="userName" class="font-color-display-only" readonly="true"
                            disabled="true">
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                        <mat-label>使用者名義（カナ）</mat-label>
                        <input id="userNameKana" matInput [value]="userNameKana" class="font-color-display-only"
                            readonly="true" disabled="true">
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                        <mat-label>変更後　使用者名義（漢字）</mat-label>
                        <input matInput formControlName="aftUserName" autocomplete="off" maxlength="50">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                        <mat-label>変更後　使用者名義（カナ）</mat-label>
                        <input matInput formControlName="aftUserNameKana" autocomplete="off" maxlength="50">
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[36%]">
                        <mat-label>使用者電話番号１</mat-label>
                        <input id="bussiness" matInput [value]="befUserTelNo1" class="font-color-display-only"
                            readonly="true" disabled="true">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　使用者電話番号１</mat-label>
                        <input matInput formControlName="aftUserTelNo1" autocomplete="off" maxlength="50">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　使用者電話番号区分１</mat-label>
                        <mat-select [(value)]='selectedAftUserTelNoDiv1.value' id="selectedAftUserTelNoDiv1">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let aftUserTelNoDiv1 of aftUserTelNoDivList1"
                                [value]="aftUserTelNoDiv1.value">{{aftUserTelNoDiv1.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[36%]">
                        <mat-label>使用者電話番号２</mat-label>
                        <input id="bussiness" matInput [value]="befUserTelNo2" class="font-color-display-only"
                            readonly="true" disabled="true">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　使用者電話番号２</mat-label>
                        <input matInput formControlName="aftUserTelNo2" autocomplete="off" maxlength="50">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　使用者電話番号区分２</mat-label>
                        <mat-select [(value)]='selectedAftUserTelNoDiv2.value' id="selectedAftUserTelNoDiv2">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let aftUserTelNoDiv2 of aftUserTelNoDivList2"
                                [value]="aftUserTelNoDiv2.value">{{aftUserTelNoDiv2.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[36%]">
                        <mat-label>使用者電話番号３</mat-label>
                        <input id="bussiness" matInput [value]="befUserTelNo3" class="font-color-display-only"
                            readonly="true" disabled="true">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　使用者電話番号３</mat-label>
                        <input matInput formControlName="aftUserTelNo3" autocomplete="off" maxlength="50">
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[32%]">
                        <mat-label>変更後　使用者電話番号区分３</mat-label>
                        <mat-select [(value)]='selectedAftUserTelNoDiv3.value' id="selectedAftUserTelNoDiv3">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let aftUserTelNoDiv3 of aftUserTelNoDivList3"
                                [value]="aftUserTelNoDiv3.value">{{aftUserTelNoDiv3.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </form>
    <h2>その他情報</h2>
    <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="fill"
                class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                <mat-label>支払方法</mat-label>
                <input id="paymentMethod" matInput [value]="payMethod" class="font-color-display-only" readonly="true"
                    disabled="true">
            </mat-form-field>
        </div>
    </div>
    <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="fill"
                class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                <mat-label>業種</mat-label>
                <input id="bussiness" matInput [value]="gyoshu" class="font-color-display-only" readonly="true"
                    disabled="true">
            </mat-form-field>
            <mat-form-field appearance="fill" [ngClass]="{ 'tw-invisible': !isVisibleElectricityContractAnnai }"
                class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                <mat-label>電気契約の案内</mat-label>
                <input id="electricityContractAnnai" matInput [value]="electricityContractAnnai"
                    class="font-color-display-only" readonly="true" disabled="true">
            </mat-form-field>
        </div>
    </div>
    <h2>プラン選択</h2>
    <mat-card-content>
        <div class="planSelect">
            <form [formGroup]="planSelectFormGroup">
                <div class="tw-mt-[10px] tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                    *ngIf="isVisibleBargainGasPricePlans">
                    お得なガス料金プラン は
                    <a [href]="bargainGasPricePlans" target="_blank">
                        こちら
                    </a>
                </div>
                <div
                    class="tw-mt-[10px] tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    重要事項説明 共通事項 は
                    <a [href]="importantItemUrl" target="_blank">
                        こちら
                    </a>
                </div>
                <div
                    class="tw-mt-[10px] tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="outline"
                        class="tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[75%]">
                        <mat-label>料金プラン</mat-label>
                        <mat-select [(value)]='selectedPricePlan.value' id="prdCode"
                            (selectionChange)="onPricePlanChange($event.value)"
                            formControlName="pricePlanForDisplayControl" required>
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let pricePlan of pricePlanList"
                                [value]="pricePlan.value">{{pricePlan.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div
                    class="tw-mt-[10px] tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <div *ngIf="ftiContractList.length>0">
                        <mat-form-field appearance="outline">
                            <mat-label>付帯契約</mat-label>
                            <mat-select [(value)]='selectedFtiContract.goodsCode' id="futaiCode"
                                formControlName="ftiContractForDisplayControl">
                                <mat-option value=""></mat-option>
                                <mat-option *ngFor="let ftiContract of ftiContractList"
                                    [value]="ftiContract.goodsCode">{{ftiContract.goodsDispAname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <mat-checkbox
                        class="check-box tw-ml-[40px] tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                        color="primary" formControlName="publicCorporationFloorHeatingSrndocReceipt"
                        [ngStyle]="{ display: !isVisiblePublicCorporationFloorHeatingSrndocReceipt ? 'none' : 'inline-flex' }">公団床暖房の申込書受領</mat-checkbox>
                </div>
            </form>
        </div>
    </mat-card-content>
    <div flexLayout="column">
        <form [formGroup]="signatureFormGroup" *ngIf="isVisibleSignatureComponent">
            <h2>署名</h2>
            <div
                class="tw-mt-[10px] tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-start tw-content-start">
                <div
                    class="tw-ml-[40px] tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[60%]">
                    以下の説明を受け、内容を承諾しました。
                </div>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-start tw-content-start">
                <div
                    class="tw-flex tw-flex-col tw-ml-[40px] tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-checkbox class="check-box" color="primary" formControlName="importantMatterExplanation"
                        required>重要事項の説明</mat-checkbox>
                    <mat-checkbox class="check-box" color="primary" formControlName="gasSafeUseExplanation"
                        required>ガスの安全使用に関する説明</mat-checkbox>
                    <mat-checkbox class="check-box" color="primary" formControlName="maiconMeterExplanation"
                        required>マイコンメータの説明</mat-checkbox>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-box-border tw-justify-center tw-items-end tw-content-end">
                <div
                    class="tw-w-[420px] tw-text-left tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-start tw-content-start">
                    <mat-label>署名</mat-label>
                </div>
                <div>
                    <canvas id="signatureCanvas" width="420" height="100" class="signatureCanvas">
                    </canvas>
                </div>
                <div class="tw-flex tw-flex-row tw-flex-wrap justify-between" style="text-align: left">

                    <div class="tw-flex tw-flex-row tw-flex-wrap">
                        <mat-radio-group name="署名区分" class="sign-radio-group" color="warn" id="signType"
                            formControlName="signatureDiv">
                            <mat-radio-button class="radio-button" value="1" [checked]="true">本人</mat-radio-button>
                            <mat-radio-button class="radio-button" value="2">代筆</mat-radio-button>
                            <mat-radio-button class="radio-button" value="3"
                                *ngIf="isVisibleRefusedSign">署名拒否</mat-radio-button>
                        </mat-radio-group>
                        <span class="tw-w-[80px]">&nbsp;</span>
                        <mat-card-actions class="btn_area_right">
                            <button type="button" mat-raised-button color="primary" (click)="onClearSignature()"
                                class="btn">署名をクリア</button>
                        </mat-card-actions>
                    </div>
                </div>
            </div>
        </form>
        <form [formGroup]="tantoushaFormGroup" *ngIf="isVisibleTantoushaComponent">
            <h2>担当者記載欄</h2>
            <div class="tw-flex tw-flex-row tw-flex-wrap justify-between">
                <div
                    class="tw-ml-[40px] tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[60%]">
                    <mat-checkbox class="check-box" color="primary"
                        [value]="procedureCompletionNoticeDeliveryNotPossible.value"
                        formControlName="procedureCompletionNoticeDeliveryNotPossible"
                        *ngIf="isVisibleProcedureCompletionNoticeDeliveryNotPossible">手続き完了おしらせ直送不可</mat-checkbox>
                </div>
            </div>
            <div class="tw-flex tw-flex-row tw-flex-wrap justify-between">
                <div
                    class="tw-ml-[40px] tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[60%]">
                    <mat-checkbox class="check-box" color="primary" [value]="procedureCompletionNoticePaperHope.value"
                        formControlName="procedureCompletionNoticePaperHope"
                        *ngIf="isVisibleProcedureCompletionNoticePaperHope">手続き完了おしらせ紙希望</mat-checkbox>
                </div>
            </div>
            <div class=" tw-flex tw-flex-row tw-flex-wrap justify-between">
                <div
                    class="tw-ml-[40px] tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[60%]">
                    <mat-checkbox class="check-box" color="primary" [value]="pricePlanNeedConfirm.value"
                        formControlName="pricePlanNeedConfirm"
                        *ngIf="isVisiblePricePlanNeedConfirm">センター要確認</mat-checkbox>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-box-border tw-justify-center tw-items-end tw-content-end">
                <div
                    class="tw-w-[420px] tw-text-left tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-start tw-content-start">
                    <mat-label>作業者メモ</mat-label>
                </div>
                <div>
                    <textarea rows="2" class="textarea-style" autocomplete="off" maxlength="150"
                        formControlName="vstinfMemo"></textarea>
                </div>
            </div>
        </form>
        <div class="tw-flex tw-flex-row tw-flex-wrap justify-between tw-justify-end">
            <mat-card-actions>
                <button type="button" mat-raised-button color="primary" (click)="onSubmit()" class="btn"
                    [disabled]="requiredCheckItemGroup.invalid || hasError">登録</button>
            </mat-card-actions>
        </div>
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center"
            *ngIf="isVisibleTurnOnStaf">
            <mat-form-field appearance="fill"
                class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                <mat-label>開栓作業担当社員番号</mat-label>
                <input id="turnonWorkchargeStafno" matInput [value]="turnonWorkchargeStafno"
                    class="font-color-display-only" readonly="true" disabled="true">
            </mat-form-field>
            <mat-form-field appearance="fill"
                class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full w-1/2">
                <mat-label>開栓作業担当社員名</mat-label>
                <input id="turnonWorkchargeStafName" matInput [value]="turnonWorkchargeStafName"
                    class="font-color-display-only" readonly="true" disabled="true">
            </mat-form-field>
        </div>
    </div>
</mat-card>